var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{class:_vm.klass},[(_vm.percentage !== null && _vm.customer.subscription)?[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}]},[_vm._v(_vm._s(_vm.percentage)+"%")]),_c('br')]:_vm._e(),(_vm.customer.subscription)?_c('span',[_vm._v(_vm._s(_vm.customer.subscription.name))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }